import FootballState from "../../../state/football-state";
import Safety from "./safety";

export default class SafetyPunt extends Safety {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            }) &&
            [FootballState.Punt, FootballState.CflKick].some((state) =>
                play.historyContains(state)
            )
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { driveTeamId } = gameContext.driveContext;
        const startingPossession = play.getContextSnapshot().isHomePossession()
            ? gameContext.homeTeamId
            : gameContext.awayTeamId;
        const finalPossession = gameContext.getPossessionTeamId();
        if (startingPossession === finalPossession && driveTeamId) {
            gameContext.setDriveContext({
                ...gameContext.getDriveContext(),
                triggerDrive: false
            });
        }
        return [];
    }
}
